import * as React from "react";

import { useOnboardingStatusContext } from "client/hooks";

import {
  ActivateInStoreEmailStep,
  DirectDebitStep,
  InStoreTrainingStep,
  SelfServeActivationStep,
} from "./Instore";

export const InStoreStatusSteps: React.FC = () => {
  const {
    isEligibleForInStoreSelfServeActivation,
    registeredCountry,
  } = useOnboardingStatusContext();

  return (
    <>
      <InStoreTrainingStep />
      {registeredCountry === "United Kingdom" ? null : <DirectDebitStep />}

      {isEligibleForInStoreSelfServeActivation ? (
        <SelfServeActivationStep />
      ) : (
        <ActivateInStoreEmailStep />
      )}
    </>
  );
};
